import { LockOutlined } from '@mui/icons-material';
import toast from 'react-hot-toast';

interface MfaReminderToastProps {
  toastId: string;
  onConfigure: () => void;
}

export const MfaReminderToast: React.FC<MfaReminderToastProps> = ({ toastId, onConfigure }) => {
  const handleConfigure = () => {
    toast.dismiss(toastId);
    onConfigure();
  };

  const handleDismiss = () => {
    toast.dismiss(toastId);
  };

  return (
    <div className="flex items-center gap-3">
      <LockOutlined className="text-white text-2xl" />
      <div className="flex-1">
        <p className="font-medium text-sm">Protege tu cuenta con MFA</p>
        <p className="text-xs text-gray-300 mt-0.5">Configura la autenticación de dos pasos</p>
      </div>
      <button
        onClick={handleConfigure}
        className="px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded-md font-medium transition-colors"
      >
        Configurar
      </button>
      <button onClick={handleDismiss} className="text-gray-400 hover:text-white transition-colors">
        ✕
      </button>
    </div>
  );
};
